// extracted by mini-css-extract-plugin
module.exports = {"container":"step-three_container__3CFCq","title":"step-three_title__c957z","text":"step-three_text__2A_c4"};